import { render, staticRenderFns } from "./BrandsBlock.vue?vue&type=template&id=825ac318&scoped=true&"
import script from "./BrandsBlock.vue?vue&type=script&lang=js&"
export * from "./BrandsBlock.vue?vue&type=script&lang=js&"
import style0 from "./BrandsBlock.vue?vue&type=style&index=0&id=825ac318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825ac318",
  null
  
)

export default component.exports